import { Dataset, DatasetFilters } from "../../api/Datasets";
import { DataFormatsVirtualizedSelectForm } from "../../common/forms/EntityForms/formsVirtualized/DataFormatsVirtualizedSelectForm";
import { EntityFilterSideBar } from "../../common/sidebar/filtersidebar/EntityFilterBar";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { DatasetsFilterForm, datasetDefaultValues, datasetsFormToFilters } from "../../Dataset/Table/DatasetsFilterBar";
import { CombinedModificationRecordEntityFilterForm } from "../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterForm";
// import { SoftDeletableEntityFilterForm } from "../../common/sidebar/filtersidebar/GenericFilters/SoftDeletableEntityFilterForm";
import { defaultAttachmentsFilters } from "./AttachmentsTable";

export const AttachmentsFilterbar = ({
  initialValues,
  dispatchTabStore,
  onFormChange,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<Dataset, DatasetsFilterForm, DatasetFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={datasetDefaultValues}
      defaultFilters={defaultAttachmentsFilters}
      formToFilters={datasetsFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <DataFormatsVirtualizedSelectForm
            id={"formats"}
            control={control}
            isMulti
            filters={{ ids: ["image-single", "doc_microsoft_sheet", "doc_acrobat_pdf", "molecule_compound"] }}
          />

          <CombinedModificationRecordEntityFilterForm
            control={control}
            currentTab={currentTab}
            initialValues={initialValues}
          />

          {/* <SoftDeletableEntityFilterForm control={control} currentTab={currentTab} initialValues={initialValues} /> */}
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
